import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";
import { Link } from "react-router-dom";

const KEY = "fife_cookie_consent";

export default function CookieBanner() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) {
      const t = setTimeout(() => {
        setShow(true);
        window.dispatchEvent(new CustomEvent("fife:cookie-visible", { detail: { visible: true } }));
      }, 700);
      return () => clearTimeout(t);
    }
  }, []);

  const close = (value) => {
    localStorage.setItem(KEY, value);
    setShow(false);
    window.dispatchEvent(new CustomEvent("fife:cookie-visible", { detail: { visible: false } }));
  };

  if (!show) return null;

  return (
    <div className="fixed left-2 right-2 md:left-6 md:right-auto md:max-w-md z-[70] fade-up"
         style={{ bottom: "calc(0.75rem + env(safe-area-inset-bottom, 0px))" }}
         data-testid="cookie-banner">
      <div className="rounded-2xl border shadow-2xl p-4 md:p-5" style={{ background: "#0a0a0a", borderColor: "rgba(255,255,255,0.15)" }}>
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
               style={{ background: "rgba(249,115,22,0.15)", color: "#f97316" }}>
            <Cookie className="w-4 h-4" />
          </div>
          <div className="flex-1">
            <div className="display font-bold text-white text-sm">Cookie & privacy</div>
            <p className="text-white/70 text-xs mt-1 leading-relaxed">
              Utilizziamo cookie tecnici e di misurazione anonima per migliorare l'esperienza sul portale FIFE.
              Puoi accettare o rifiutare. Consulta la <Link to="/privacy" className="underline text-white" data-testid="cookie-privacy-link">Privacy Policy</Link>.
            </p>
          </div>
          <button onClick={() => close("declined")} aria-label="Chiudi" data-testid="cookie-close"
                  className="text-white/60 hover:text-white p-1 rounded-full">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="mt-3 flex gap-2 justify-end">
          <Button variant="outline" onClick={() => close("declined")} data-testid="cookie-decline"
                  className="rounded-full text-white border-white/25 bg-transparent hover:bg-white/10 h-9 px-4 text-sm">
            Solo tecnici
          </Button>
          <Button onClick={() => close("accepted")} data-testid="cookie-accept"
                  className="btn-brand rounded-full h-9 px-4 text-sm">
            Accetta tutti
          </Button>
        </div>
      </div>
    </div>
  );
}
